import { getIsDarkMode } from '~/utils/get-is-dark-mode'

export const getTourOverlayConfig = () => {
  if (!getIsDarkMode()) return

  const foregroundHsl = getComputedStyle(document.documentElement).getPropertyValue('--foreground').trim()
  return {
    overlayColor: `hsl(${foregroundHsl})`,
    overlayOpacity: 0.16,
  }
}
